import mietpreisbremse from '../../fields/cases/mietpreisbremse';

export const MUTATION_UPDATE_MPB_CASE = /* GraphQL */ `
	mutation($input: MietpreisbremseCaseUpdate!, $id: String!) {
		updateMietpreisbremseCase(input: $input, id: $id) {
			${mietpreisbremse}
		}
	}
`;
